// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_bI3FN","avatar":"index_avatar_wZ_0Y"};